<template>
  <v-data-table
    :headers="headers"
    :items="formattedItems"
    :loading="loading"
    must-sort
    :no-data-text="$t('texts.noCooperationAgreements')"
    :no-results-text="$t('texts.noSearchEntries')"
    :footer-props="{ itemsPerPageText: $t('texts.rowsPerPage')}"
    class="elevation-0"
    :hide-default-footer="items.length <= 5 || loading"
  >
    <template v-slot:item.status="{ item }">
      <v-tooltip
        v-if="item.status !== 'CANCELLED' && item.active"
        right color="green"
      >
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" color="green">check_circle</v-icon>
        </template>
        <span>{{ $t('texts.cooperationAgreementValid') }}</span>
      </v-tooltip>
      <v-tooltip
        v-else-if="item.status !== 'CANCELLED' && !item.active"
        right color="grey"
      >
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" color="grey">check_circle</v-icon>
        </template>
        <span>{{ $t('texts.cooperationAgreementValid') }}</span>
      </v-tooltip>
      <v-tooltip
        v-else
        right color="error"
      >
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" color="error">cancel</v-icon>
        </template>
        <span>{{ $t('texts.cooperationAgreementInvalid') }}<br>{{ $t('texts.questionsToCompany') }}</span>
      </v-tooltip>
    </template>
    <template v-slot:item.endDate="{ item }">
      {{ item.period }}
    </template>
    <template v-slot:item.url="{ item }">
      <v-tooltip color="info" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon class="mx-0"
            @click="showPdfDialog({
              title: $tc('texts.cooperationAgreement', 1),
              pdfLink: `${item.url}`
            })">
            <v-icon color="primary">insert_drive_file</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('texts.displayContract') }}</span>
      </v-tooltip>
    </template>
    <template v-slot:item.actions="{ item }">
      <template v-if="item.jobs.job1.company_id == selectedCompanyId">
        <v-btn
          v-if="getJobPeriod(item.jobs.job1) !== 'past'"
          icon @click="openEditEmployeeDialog(item)"
        >
          <v-icon color="primary">mode_edit</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          v-if="getJobPeriod(item.jobs.job2) !== 'past'"
          icon @click="openEditEmployeeDialog(item)"
        >
          <v-icon color="primary">mode_edit</v-icon>
        </v-btn>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TableCooperationAgreements',
  props: {
    loading: {
      type: Boolean,
    },
    items: {
      type: Array,
    },
  },
  computed: {
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
    headers() {
      const headers = [
        {
          text: this.$i18n.t('texts.status'),
          value: 'status',
          sortable: false,
        },
        {
          text: this.$i18n.t('texts.employees'),
          value: 'name',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.workplace'),
          value: 'endDate',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.company.label'),
          value: 'company',
          align: 'left',
        },
        {
          text: '',
          value: 'url',
          sortable: false,
          align: 'center',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
        },
      ];
      return headers;
    },
    formattedItems() {
      if (this.items.length > 0) {
        return this.items
          .map((item) => {
            let ownJob = '';
            let otherJob = '';
            if (item.jobs.job1.company_id === this.selectedCompanyId) {
              ownJob = item.jobs.job1;
              otherJob = item.jobs.job2;
            } else {
              ownJob = item.jobs.job2;
              otherJob = item.jobs.job1;
            }
            const startDate = this.$options.filters.formatDateShort(ownJob.start_date);
            const endDate = this.$options.filters.formatDateShort(ownJob.end_date);
            const agreementItem = {
              name: `${item.employee.first_name} ${item.employee.last_name}`,
              period: `${startDate} - ${endDate}`,
              company: otherJob.company,
              startDate: ownJob.start_date,
              endDate: ownJob.end_date,
            };
            const combinedItem = { ...item, ...agreementItem };
            return combinedItem;
          })
          .sort((a, b) => moment(b.endDate).diff(a.endDate, 'days'));
      }
      return [];
    },
  },
  methods: {
    showPdfDialog(item) {
      this.$eventBus.$emit('show-pdf-dialog', item);
    },
    getJobPeriod(item) {
      if (moment().isAfter(item.end_date)) {
        return 'past';
      } if (moment().isBetween(item.start_date, item.end_date)) {
        return 'current';
      }
      return 'future';
    },
    openEditEmployeeDialog(data) {
      const item = data.jobs.job1.company_id === this.selectedCompanyId ? data.jobs.job1 : data.jobs.job2;
      const periodType = this.getJobPeriod(item);
      const payload = {
        resume_entry_id: item.id,
        type: periodType,
        employee_first_name: data.employee.first_name,
        employee_last_name: data.employee.last_name,
        title: item.title,
        start_date: item.start_date,
        end_date: item.end_date,
        workload: item.workload,
      };
      this.$eventBus.$emit('show-edit-employee-dialog', payload);
    },
  },
};
</script>
